import * as yup from "yup";
import { labelValues, softwareApplicationValues } from "./tagsValidationSchema";

export const externalLinkValidationSchema = yup.object().shape({
  title: yup.string().required("Title is required.").max(128, "Title cannot exceed 128 characters."),
  description: yup.string().required("Description is required.").max(256, "Description cannot exceed 256 characters."),
  urlText: yup.string().required("Button label is required.").max(50, "Button label cannot exceed 50 characters."),
  url: yup.string().url("URL must be a valid URL format (e.g., http://example.com).").required("URL is required."),
});

// Schema for the external link settings form
export const externalLinkSettings = yup.object().shape({
  labels: labelValues,
  softwareApplications: softwareApplicationValues,
});
